import React from 'react';
import { useIntl } from 'react-intl';
import Box from '@nubank/nuds-web/components/Box/Box';
import styled from 'styled-components';

import useWindowSize from '@nubank/www-latam-commons/utils/hooks/useWindowSize';

import TypographyColorHighlight from '../../../../components/TypographyColorHighlight/TypographyColorHighlight';
import AppStoreBadge from '../../../../components/AppStoreBadge/AppStoreBadge';
import AppStoreButtonsContainer from '../../../Registration/patterns/DecisionStep/styles/AppStoreButtonsContainer';
import useMobileOS from '../../../../utils/hooks/useMobileOS';
import { downloadAppBtnLP } from '../../../Registration/tracking';

const StyledTypography = styled(TypographyColorHighlight)`
  @media (width >= 1151px) {
    font-size: 2.2rem;
  }
`;

const StyledBox = styled(Box)`
  cursor: pointer;

  :hover {
    opacity: 0.8;
  }
`;

const DowloadApp = () => {
  const { formatMessage } = useIntl();
  const mobileSystem = useMobileOS();
  const { width } = useWindowSize();
  const isDesktop = width > 1151;

  const redirectToStore = (store, operatingSystem, page) => {
    window.open(formatMessage({ id: `CREDIT_CARD.DOWNLOAD_APP.${store}.PATH` }), '_blank');
    downloadAppBtnLP(operatingSystem, page);
  };

  return (
    <Box
      tag="section"
      display="flex"
      flexDirection={{ xs: 'column' }}
      alignItems={{ xs: 'center' }}
      justifyContent={{ xs: 'auto', md: 'space-between' }}
      marginTop={{ xs: '16x', lg: '0' }}
      marginBottom={{ xs: '16x', lg: '24x' }}
    >
      <Box
        width={{ xs: '85%', md: '70%', lg: '50%' }}
        maxWidth={{ xs: 'auto', md: '700px', lg: '550px' }}
      >

        <StyledTypography
          intlKey="CREDIT_CARD.DOWNLOAD_APP"
          variant="heading3"
          tag="p"
          textAlign="center"
          highlightText={formatMessage({ id: 'CREDIT_CARD.DOWNLOAD_APP.HIGHLIGHT' })}
          highlightColor="primary.default"
          animate
          marginBottom={{ xs: '12x' }}
          whiteSpace={{ xs: 'pre-line', md: 'normal' }}
        />

        <Box
          display="flex"
          flexDirection={{ xs: 'column' }}
          alignItems={{ xs: 'center' }}
          marginTop={{ xs: '4x' }}
        >

          <AppStoreButtonsContainer>
            { isDesktop || (mobileSystem === 'ios' || mobileSystem === 'other')
              ? (
                <StyledBox onClick={() => redirectToStore('APPLESTORE', 'ios', 'credito')}>
                  <AppStoreBadge platform="ios" variant="dark" />
                </StyledBox>
              )
              : null}
            { isDesktop || (mobileSystem === 'android' || mobileSystem === 'other')
              ? (
                <StyledBox onClick={() => redirectToStore('GOOGLESTORE', 'android', 'credito')}>
                  <AppStoreBadge platform="android" variant="dark" />
                </StyledBox>
              )
              : null}
          </AppStoreButtonsContainer>
        </Box>

      </Box>
    </Box>
  );
};

export default DowloadApp;
